import { mCBQS060DeleteRequest, mCBQS060ErrorConfirmRequest, mCBQS060FindRequest, mCBQS060InitRequest, mCBQS060TranstionRequest } from "apis/MCBQS060Api";
import { openModal, openSnackbar } from "reducers/messageReducer";
import { deleteSetPrintManagement, finishLoading, getErrorConfirmInfo, getFindResult, getInitSetPdf, setErrorConfirmDialog, setErrorConfirmInfo, setSearchCondition, setSelectionManagementOption, setSetPdfManagementResult, startLoading, toMCAXS010Search } from "reducers/setPdfDownloadReducer";
import { all, call, put, select, takeEvery, takeLatest } from "redux-saga/effects";
import { routeList } from "routes/routes";
import { getSetPrintManagementSearchCondition } from "selectors";
import { magiContants } from "utils/contants";
import history from 'utils/history'

// 初期表示
function* MCBQS060InitSaga(action: ReturnType<typeof getInitSetPdf>) {
  try {
    yield put(startLoading())
    yield put(setSetPdfManagementResult([]))
    const data = yield call(mCBQS060InitRequest, action.payload)
    yield put(setSearchCondition(action.payload))
    yield put(setSetPdfManagementResult(data.setPdfManagementResult))
    yield put(setSelectionManagementOption(data.selectionManagementOption))
  } catch (error) {
    yield put(openModal(error.message))
  } finally {
    yield put(finishLoading())
  }
}

// 検索
function* MCBQS060FindSaga(action: ReturnType<typeof getFindResult>) {
  try {
    yield put(setSetPdfManagementResult([]))
    const data = yield call(mCBQS060FindRequest, action.payload)
    yield put(setSearchCondition(action.payload))
    yield put(setSetPdfManagementResult(data.setPdfManagementResult))
    yield put(setSelectionManagementOption(data.selectionManagementOption))
  } catch (error) {
    yield put(openModal(error.message))
  }
}

// "エラー確認"ボタン押下時
function* MCBQS060ErrorConfirmSaga(action: ReturnType<typeof getErrorConfirmInfo>) {
  try {
    const data = yield call(mCBQS060ErrorConfirmRequest, action.payload)
    yield put(setErrorConfirmDialog(true))
    yield put(setErrorConfirmInfo(data))
  } catch (error) {
    yield put(openModal(error.message))
  }
}

// "出力件数"リンク押下時
function* MCBQS060TranstionSaga(action: ReturnType<typeof toMCAXS010Search>) {
  try {
    const data = yield call(mCBQS060TranstionRequest, action.payload)
    // 遷移前パラメータ編集
    const applicantManagement = {
      pathname: routeList.applicantList,
      state: {
        request: {
          applicantIdList: data && data.length > 0 ? data : [],
          screenId: 'MCBQS060'
        }
      },
    }
    // 画面に応募者一覧を遷移する
    history.push(applicantManagement)
  } catch (error) {
    yield put(openModal(error.message))
  }
}

// ダイアログ：削除チェック OKボタン押下時
function* MCBQS060DeleteSetPrintSaga(action: ReturnType<typeof deleteSetPrintManagement>) {
  try {
    const deleteFlag = yield call(mCBQS060DeleteRequest, action.payload)
    if (deleteFlag === magiContants.DELET_FLAG_0) {
      // 再検索条件取得
      const searchCondition: ReturnType<typeof getSetPrintManagementSearchCondition> = yield select(
        getSetPrintManagementSearchCondition
      )
      // 初期化
      yield put(setSetPdfManagementResult([]))
      // 検索処理
      const data = yield call(mCBQS060FindRequest, searchCondition)
      yield put(setSetPdfManagementResult(data.setPdfManagementResult))
      yield put(setSelectionManagementOption(data.selectionManagementOption))
      // 削除成功メッセージ出力
      yield put(openSnackbar("PDFデータを削除しました。"))
    }
  } catch (error) {
    yield put(openModal(error.message))
  }
}

export default function* setPdfDownloadSaga() {
  yield all([
    takeEvery(getInitSetPdf, MCBQS060InitSaga),
    takeEvery(getFindResult, MCBQS060FindSaga),
    takeLatest(getErrorConfirmInfo, MCBQS060ErrorConfirmSaga),
    takeEvery(toMCAXS010Search, MCBQS060TranstionSaga),
    takeEvery(deleteSetPrintManagement, MCBQS060DeleteSetPrintSaga),
  ])
}